import React, {useEffect, useRef} from "react";
import L from "leaflet";
import {decodePolyline} from "../../../utils/helpers";

export const OrderDetailPolyline = ({
    mapInstance,
    encodedPolylines,
    path,
    strokeColor = "#000000",
    strokeWeight = 3,
    strokeOpacity = 1.0,
    isVisible = true
}) => {
    const polylineRef = useRef(null);

    useEffect(() => {
        if (!mapInstance || (!encodedPolylines && !path) || !isVisible) {
            // Clear existing polyline if not visible
            if (polylineRef.current) {
                mapInstance.removeLayer(polylineRef.current);
                polylineRef.current = null;
            }
            return;
        }

        // Clear existing polyline
        if (polylineRef.current) {
            mapInstance.removeLayer(polylineRef.current);
            polylineRef.current = null;
        }

        try {
            let leafletPath;

            if (encodedPolylines) {
                const decodedPath = decodePolyline(encodedPolylines);
                // Convert decoded path to Leaflet format
                leafletPath = decodedPath.map(point => [point.lat, point.lng]);
            } else if (path) {
                // Direct path array
                leafletPath = path.map(point => [point.lat, point.lng]);
            } else {
                return;
            }

            // Create polyline
            const polyline = L.polyline(leafletPath, {
                color: strokeColor,
                weight: strokeWeight,
                opacity: strokeOpacity
            });

            // Add polyline to map
            polyline.addTo(mapInstance);
            polylineRef.current = polyline;
        } catch (error) {
            console.error("Error drawing polyline:", error);
        }

        return () => {
            // Cleanup on unmount
            if (polylineRef.current) {
                mapInstance.removeLayer(polylineRef.current);
                polylineRef.current = null;
            }
        };
    }, [mapInstance, encodedPolylines, path, strokeColor, strokeWeight, strokeOpacity, isVisible]);

    return null;
};
